import { Phonenumber } from 'data/firestore/phonenumber/types';
import { CellWrapper } from '../../../columns/styled';
import PersonaCell from './personaCell';
import WorkflowCell from './workflowCell';

interface Props {
    value?: string;
    row?: Phonenumber;
}

const PersonaColumn = ({ value, row }: Props) => {
    if (row?.voicePipelineServer?.id === 'workflow') {
        return <WorkflowCell workflowId={row.voicePipelineServer.params.workflowId} />;
    }

    if (!value) {
        return <CellWrapper />;
    }

    return <PersonaCell value={value} />;
};

export default PersonaColumn;
